import React from 'react';

import { SettingInfo } from '@components/card-control/settings/modals/InfoModal';
import { SpendingLimitCategory } from '@components/card-control/types';

export interface ICardControlContext {
    selectedCategory: SpendingLimitCategory | null;
    selectCategory: (category: SpendingLimitCategory) => void;
    removeSelectedCategory: () => void;

    selectedInfoModal: SettingInfo | null;
    selectInfoModal: (infoModal: SettingInfo | null) => void;
    closeInfoModal: () => void;
}

const CardControlContext = React.createContext<ICardControlContext>({
    selectedCategory: null,
    selectCategory: () => {},
    removeSelectedCategory: () => {},

    selectedInfoModal: null,
    selectInfoModal: () => {},
    closeInfoModal: () => {},
});

export default CardControlContext;
